export const InequalityLeftBlueDouble = () => {
  return (
    <svg width='30' height='24' viewBox='0 0 43 52' fill='none'>
      <path
        d='M22 48L6.41745 27.8343C5.58259 26.7539 5.58259 25.2461 6.41745 24.1657L22 4'
        stroke='#6696FF'
        stroke-width='10'
      />
      <path
        d='M39 48L23.4174 27.8343C22.5826 26.7539 22.5826 25.2461 23.4174 24.1657L39 4'
        stroke='#6696FF'
        stroke-width='10'
      />
    </svg>
  );
};
